<template>
  <div>
    <div>
      <v-btn outlined rounded small :color="color" @click="dialog_novo_horario_ativo = true">
        <v-icon small>mdi-plus</v-icon>
        Adicionar horário
      </v-btn>

      <div v-if="HORARIOS_COMPUTED.length > 0" class="pl-1">
        <p class="ma-0 pa-0 pt-1 font-weight-medium">Horários</p>

        <ul class="ml-n2">
          <li v-for="(horario, key) in HORARIOS_COMPUTED" :key="key">
            {{ horario }}
            <v-icon small class="cursor-pointer font-13 ml-1" @click="removerHorario(horario);editarHorario(horario);">mdi-pencil</v-icon>
            <v-icon small class="cursor-pointer font-13 ml-2" @click="removerHorario(horario)">mdi-delete</v-icon>
          </li>
        </ul>
      </div>
    </div>

    <SysDialog
      v-model="dialog_novo_horario_ativo"
      titulo="Novo Horário"
      :largura="330"
      ocultar-acoes
    >
      <template #titulo>
        <div class="d-flex align-center w-full mt-n2">
          <span>Novo Horário</span>

          <v-spacer />

          <v-btn icon @click="dialog_novo_horario_ativo = ! dialog_novo_horario_ativo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </template>

      <div class="d-flex align-center w-full mt-n3">
        <v-text-field
          v-model="novo_horario"
          outlined
          hide-details
          dense
          clearable
          type="time"
          autofocus
          @keyup.enter="adicionarHorario()"
        />

        <v-btn
          color="primary"
          class="ml-2"
          :disabled="!HORARIO_VALIDO_COMPUTED"
          @click="adicionarHorario()"
        >
          salvar
        </v-btn>
      </div>

      <span
        v-if="HORARIOS_COMPUTED.includes(novo_horario)"
        class="font-11 pl-1 text-red-1600"
      >
        Horário já está na lista
      </span>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {computed, ref, watch} from "vue";

export default {
  name: 'Horarios',
  components: {SysDialog},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Array,
    color: {
      type: String,
      default: 'primary'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const dialog_novo_horario_ativo = ref(false);
    const novo_horario = ref('');

    watch(dialog_novo_horario_ativo, () => {
      if (dialog_novo_horario_ativo.value) return;
      novo_horario.value = '';
    });

    const HORARIOS_COMPUTED = computed({
      get: () => props.modelValue,
      set: valor => emit('update:modelValue', valor)
    });

    const HORARIO_VALIDO_COMPUTED = computed(() => novo_horario.value
      && novo_horario.value.length > 0
      && !HORARIOS_COMPUTED.value.includes(novo_horario.value)
    );

    function adicionarHorario() {
      if (!HORARIO_VALIDO_COMPUTED.value) return;
      HORARIOS_COMPUTED.value.push(novo_horario.value);
      novo_horario.value = '';
      dialog_novo_horario_ativo.value = false;
    }

    function editarHorario(horario) {
      novo_horario.value = horario;
      dialog_novo_horario_ativo.value = true;
    }

    function removerHorario(horario) {
      HORARIOS_COMPUTED.value = HORARIOS_COMPUTED.value.filter(item => item !== horario);
    }

    return {
      dialog_novo_horario_ativo,
      novo_horario,
      HORARIOS_COMPUTED,
      HORARIO_VALIDO_COMPUTED,
      adicionarHorario,
      editarHorario,
      removerHorario,
    }
  }
}
</script>

<style scoped>
</style>
